var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{ref:"svgRef",staticClass:"icon",class:[_vm.data.class, _vm.data.staticClass]},[_c('use',{attrs:{"xlink:href":("#" + (_vm.props.id))}})])}
var staticRenderFns = []

export { render, staticRenderFns }